import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@/inversify.config';
let FolderInfoModelImpl = class FolderInfoModelImpl {
    constructor() {
        this._folderInfo = proxy(null);
    }
    get folderInfo() {
        return this._folderInfo.value;
    }
    updateFolderInfo(folderInfo) {
        this._folderInfo.value = folderInfo;
    }
    updateFolderInfoImportInfo(importInfo) {
        if (this._folderInfo.value) {
            this._folderInfo.value.import_info = importInfo;
        }
    }
    updateFolderTotalCountByKey(key, count) {
        if (this._folderInfo.value) {
            this._folderInfo.value[key] = count;
        }
    }
    subscribeFolderInfo(callback) {
        const dispose = subscribe(() => this._folderInfo.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
FolderInfoModelImpl = __decorate([
    injectable()
], FolderInfoModelImpl);
export { FolderInfoModelImpl };
